import { IMappingTextPack, IRecordTypeFeatureInfoClick, MapListRecordItem } from "esdm-map";
import { BuckinghamshireRecordSubType } from "./BuckinghamshireRecordTypes";
import { HbsmrUser } from "./HbsmrUser";


export class BuckinghamshireMapListRecordItem extends MapListRecordItem {       

    private __mappingTextPack: IMappingTextPack;

    public constructor(
        mappingTextPack: IMappingTextPack,
        private _user: HbsmrUser
    ) {
        super(mappingTextPack);
        this.__mappingTextPack = mappingTextPack        
    }

    public getHtml = (feature: IRecordTypeFeatureInfoClick): string => {
        let html: string = "";
        let featurePropertyNameForId = "uid";
        let layerType: string = feature.layerGroup.layerType;

        let fullHtml = `
                     <li>
                        <a href="/[controller]/[${featurePropertyNameForId}]" title="${this.__mappingTextPack.goToDetails}"><span><i class="far fa-info-circle" aria-hidden="true"></i></span></a>
                        &nbsp;
                        <a href="/[controller]/[${featurePropertyNameForId}]" title="${this.__mappingTextPack.goToDetails}">                               
                            <span>[name]</span>               
                        </a>
                        <a class="showOnMap" title="${this.__mappingTextPack.centreOnMap}" data-recordtype="${layerType}" data-id="[id]">                                                
                            <i class="far fa-map-marked-alt fa-lg" aria-hidden="true"></i>
                        </a>
                     </li>`;

        let noLinksHtml = `
                     <li>                                                                        
                        <span>[name]</span>                                       
                        <a class="showOnMap" title="${this.__mappingTextPack.centreOnMap}" data-recordtype="${layerType}" data-id="[id]">                                                
                            <i class="far fa-map-marked-alt fa-lg" aria-hidden="true"></i>
                        </a>
                     </li>`;

        //add controller (or any arbitrary data) to the data object
        switch (feature.recordType.toLowerCase()) {
            case "mon":
                feature.data.controller = "Monument";
                html = fullHtml;
                break;

            case "event":
                feature.data.controller = "Event";
                html = this.isAuthenticated() ? fullHtml : noLinksHtml;
                break;

            case "desig":
                feature.data.controller = "Designation";

                if (feature.recordSubTypeCode == BuckinghamshireRecordSubType.LocallyListedBuilding) {
                    //LocallyListedBuilding links visible to all users
                    html = fullHtml;
                } else {
                    html = this.isAuthenticated() ? fullHtml : noLinksHtml;
                }

                break;

            case "cons":
                feature.data.controller = "Consultation";
                html = this.isAuthenticated() ? fullHtml : noLinksHtml;
                break;
        }        

        //feature.data.id = feature.getId();
        return this.replaceTokens(html, feature.data);
    }

    protected replaceTokens = (html, data): string => {
        //go thru html string and replace any tokens with attribute values
        for (var attributeName in data) {
            if (data.hasOwnProperty(attributeName)) {
                html = html.replace(new RegExp("\\[" + attributeName + "\\]", "g"), data[attributeName]);
            }
        }
        return html;
    }

    protected isAuthenticated = (): boolean => {
        return this._user !== null;
    }

    //private controller = (feature: IRecordTypeFeatureInfoClick): string => {
    //    let val: string = "";

    //    switch (feature.recordType.toLowerCase()) {
    //        case "mon":
    //            val = "Monument";
    //            break;
    //        case "event":
    //            val = "Event";
    //            break;
    //        case "desig":
    //            val = "Designation";
    //        case "cons":
    //            val = "Consultation";
    //            break;
    //    }
    //    return val;
    //}

}